import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
	const { hash, pathname } = useLocation();

	useEffect(() => {
		if (hash) {
			const element = document.querySelector(hash);
			if (element) {
				const yOffset = -100; // Adjust this value to set the offset
				const y =
					element.getBoundingClientRect().top + window.scrollY + yOffset;

				window.scrollTo({ top: y, behavior: "smooth" });
			}
		}
		else if(pathname){
			window.scrollTo(0, 0);
		}
	}, [hash, pathname]);

	return null;
}

export default ScrollToTop;
